import React, { Component } from 'react';
import { PropTypes as MobxPropTypes, inject, observer } from 'mobx-react';
import { Row, Col } from 'react-bootstrap';
import { Form, Input } from 'formsy-react-components';
import { withRouter } from "react-router-dom";
import { withCookies, Cookies } from 'react-cookie';
import { Heading, ContainerBox } from '../AdminStyle';
import { instanceOf } from 'prop-types';
import { LogeButtonSlim } from '../../GeneralStyle'
import InvoiceTable from '../../Tables/InvoiceTable';
import config from 'react-global-configuration';
import ConfirmContractResendModal from "../../internal/Modals/ConfirmContractResendModal"
import EditContractFeeModal from "../../internal/Modals/EditContractFeeModal"
import Parse from 'parse'

@inject("adminStore")

@observer
class ContractForm extends Component {
		constructor(props) {
				super(props)
				this.state = {
						contract: this.props.contract,
						generationState: 0,
						acceptState: 0,
				}
		}

		componentDidUpdate(prevProps) {
			if (prevProps.contract !== this.props.contract)
				this.setState({ contract: this.props.contract })
		}

		generate = () => {
			this.setState({ generationState: 1 })
			Parse.Cloud.run("generateNewContract", { contractId: this.state.contract.objectId })
				.then(result => {
					this.setState({ generationState: 3, contract: {...this.state.contract, isArchived: true} })
				})
				.catch(error => {
					console.error("error", error)
					this.setState({ generationState: 2 })
				})
		}

		accept = () => {
			this.setState({ acceptState: 1 })

	    const contractQuery = new Parse.Query("Contract")
	    contractQuery.get(this.state.contract.objectId).then(object => {
	      object.set("isAccepted", true)
	      return object.save()
	    }).then(() => {
	      this.setState({ acceptState: 3 })
				setTimeout(() => {
					this.setState({ contract: {...this.state.contract, isAccepted: true } })
				}, 2000);
	    }).catch(error => {
				this.setState({ acceptState: 2 })
	      console.error("error", error)
	    })
		}

		render() {

				const contract = this.state.contract
				const invoices = this.props.invoices

				if(!(contract && contract.company))
					return (
						<ContainerBox>
						<Row style={{ padding: 25, margin: 'auto' }}>
						<Col md={12} style={{textAlign: "center", color: "black"}}>
							Vertrag konnte nicht geladen werden
						</Col>
						</Row>
						</ContainerBox>
					)

				return (
						<div style={{maxWidth: 1200, margin: "0 auto"}}>
						<ContainerBox>
								<Row style={{ padding: 25, margin: 'auto' }}>
									<Heading style={{paddingLeft: 0, marginLeft: 37, display: "inline-block"}}>Vertrag: { contract.objectId }</Heading>

									<LogeButtonSlim
										hoverFontColor={"white"}
										style={{marginRight: 30, float: "right"}}
										disabled={contract.url ? false : true}
										onClick={() => { window.open(config.get('CLOUDINARY_URL') + contract.url, "_blank") }}>
											{ contract.url ? "Datei anzeigen" : "Datei nicht vorhanden" }
									</LogeButtonSlim>

									<div style={{ paddingLeft: 0, marginLeft: 37, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 20 }}></div>

										<Form
												className={'dashboard-form'}
												layout={'vertical'}
												validateOnSubmit={false}
												validatePristine={false}
												formNoValidate
												noValidate
										>

											<Col md={10}>
												<Input
													name="company"
													label="Firma"
													value={ contract.company.shortname }
													type="text"
													disabled
												/>
											</Col>

											<Col md={2} style={{ paddingTop: 35, paddingRight: 35 }}>
												<LogeButtonSlim
								          hoverFontColor={"white"}
													style={{width: "100%"}}
								          onClick={() => { this.props.history.push(`/internal/admin/companies/${contract.company.objectId}`) }}>
								            anzeigen
								        </LogeButtonSlim>
											</Col>

											<Col md={6}>
												<Input
													name="year"
													label="Jahr"
													value={ contract.year }
													type="text"
													disabled
												/>
											</Col>

											<Col md={3}>
												<Input
													name="fee"
													label="Jahres Betrag"
													value={ contract.fee + " €" }
													type="text"
													disabled
												/>
											</Col>

											<Col md={3} style={{ paddingTop: 35, paddingRight: 35 }}>
												<LogeButtonSlim
													hoverFontColor={"white"}
													style={{width: "100%"}}
													onClick={() => { this.editContractFeeModal.open() } }
													loading>
														Betrag anpassen
												</LogeButtonSlim>
											</Col>

											<Col md={6}>
												<Input
													name="accepted"
													label="Status"
													value={ contract.isArchived ? "Archiviert" : contract.isAccepted ? "Bestätigt ✔" : "Noch nicht bestätigt ✘" }
													type="text"
													disabled
												/>
											</Col>
											{ !contract.isAccepted &&
											<Col md={3} style={{ paddingTop: 35, paddingLeft: 35, paddingRight: 45 }}>
												<LogeButtonSlim
													hoverFontColor={"white"}
													style={{width: "100%"}}
													onClick={() => { this.confirmResendModal.open() } }
													loading>
														erinnerung senden
												</LogeButtonSlim>
											</Col>
											}
											{ !contract.isArchived &&
												<Col md={3} style={{ paddingTop: 35, paddingRight: 35}}>
													<LogeButtonSlim
														hoverFontColor={"white"}
														style={{width: "100%"}}
														disabled={this.state.generationState === 0 || this.state.generationState === 2 ? false : true }
														onClick={this.generate}>
															 { this.state.generationState === 0 ? "Vertrag neu generieren" : this.state.generationState === 1 ? "Laden ..." : this.state.generationState === 2 ? "Generierungsfehler" : "Erfolgreich generiert" }
													</LogeButtonSlim>
												</Col>
											}

											{ contract.isManual == true && !contract.isAccepted && !contract.isArchived &&
												<Col md={12} style={{ paddingTop: 35, paddingLeft: 35, paddingRight: 45 }}>
													<LogeButtonSlim
														hoverFontColor={"white"}
														disabled={this.state.acceptState === 0 || this.state.acceptState === 2 ? false : true }
														onClick={this.accept}>
														  { this.state.acceptState === 0 ? "Vertrag akzeptieren" : this.state.acceptState === 1 ? "Laden..." : this.state.acceptState === 2 ? "Fehler" : "Vertrag akzeptiert" }

													</LogeButtonSlim>
												</Col>

											}
											<Col md={12} style={{ paddingTop: 35, paddingRight: 35, textAlign: "center", }}>
												<LogeButtonSlim
								          hoverFontColor={"white"}
								          onClick={() => { this.props.history.push(`/internal/admin/contracts/`) }}>
								            zurück zur Liste
								        </LogeButtonSlim>
											</Col>
										</Form>
								</Row>
								</ContainerBox>
								<ContainerBox>
									<Heading style={{ paddingLeft: 0, marginLeft: 37 }}>zugehörige Rechnungen</Heading>
									<div style={{ color: 'black', margin: "15px 35px 35px 35px" }} className={'bootstrap-table users'}>
										<InvoiceTable data={ invoices } hide={["contract", "company"]} onRowClick="details"/>
									</div>
								</ContainerBox>
								<ConfirmContractResendModal
									contract={contract}
									onResend={() => this.props.adminStore.sendContractReminderMail(contract.objectId)}
									ref={instance => { this.confirmResendModal = instance; }}/>
								<EditContractFeeModal
									contract={contract}
									editFee={fee => this.setState({contract: {...this.state.contract, fee: fee}})}
									ref={instance => { this.editContractFeeModal = instance; }}/>
					</div>
				);
		}
}

ContractForm.propTypes = {
		userStore: MobxPropTypes.observableObject,
		cookies: instanceOf(Cookies).isRequired
};

export default withCookies(withRouter(ContractForm));



// WEBPACK FOOTER //
// /src/components/admin/Forms/ContractForm.js